(function () {

  /*
   * UNIVERSAL VARIANT GALLERY FILTER
   *
   * This script ONLY filters images.
   *
   * Dawn remains responsible for:
   * - active media
   * - variant featured image
   * - sliders
   * - thumbnails
   * - price
   * - add to cart
   */


  function normalizeValue(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[–—−]/g, '-')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }


  function getSelectedGalleryValue(variantPicker) {

    const position = parseInt(
      variantPicker.dataset.galleryOptionPosition,
      10
    );

    if (!position) {
      return null;
    }


    const optionGroups =
      variantPicker.querySelectorAll(
        '.product-form__input, .hidden-product-option'
      );


    const group =
      optionGroups[position - 1];


    if (group) {

      const checkedRadio =
        group.querySelector(
          'input[type="radio"]:checked'
        );


      if (checkedRadio) {
        return checkedRadio.value;
      }


      const select =
        group.querySelector('select');


      if (select) {
        return select.value;
      }

    }


    /*
     * Fallback to Dawn selected variant data
     */

    const variantJSON =
      variantPicker.querySelector(
        'script[data-selected-variant]'
      );


    if (variantJSON) {

      try {

        const variant =
          JSON.parse(
            variantJSON.textContent
          );


        if (
          variant &&
          Array.isArray(variant.options) &&
          variant.options[position - 1]
        ) {

          return variant.options[
            position - 1
          ];

        }

      } catch (error) {}

    }


    return null;
  }


  function getGalleryTag(item) {

    const image =
      item.querySelector(
        'img[alt]'
      );


    if (!image) {
      return null;
    }


    const alt =
      image.getAttribute('alt') || '';


    const index =
      alt
        .toLowerCase()
        .indexOf('gallery:');


    if (index === -1) {
      return null;
    }


    const value =
      alt
        .substring(
          index + 'gallery:'.length
        )
        .trim();


    if (!value) {
      return null;
    }


    return normalizeValue(value);
  }


  function filterGallery(variantPicker) {

    if (!variantPicker) {
      return;
    }


    const sectionId =
      variantPicker.dataset.section;


    if (!sectionId) {
      return;
    }


    const selectedValue =
      getSelectedGalleryValue(
        variantPicker
      );


    if (!selectedValue) {
      return;
    }


    const selectedGallery =
      normalizeValue(
        selectedValue
      );


    const gallery =
      document.getElementById(
        `MediaGallery-${sectionId}`
      );


    if (!gallery) {
      return;
    }


    /*
     * Main gallery items
     */

    const mainItems =
      gallery.querySelectorAll(
        '.product__media-item'
      );


    /*
     * Thumbnail items
     */

    const thumbnailItems =
      gallery.querySelectorAll(
        '.thumbnail-list__item'
      );


    const allItems = [
      ...mainItems,
      ...thumbnailItems
    ];


    allItems.forEach((item) => {

      const itemGallery =
        getGalleryTag(item);


      /*
       * No gallery tag:
       * shared image.
       *
       * Keep it visible for every Style.
       */

      if (!itemGallery) {

        item.classList.remove(
          'variant-gallery-hidden'
        );

        return;

      }


      /*
       * Matching gallery:
       * show it.
       */

      if (
        itemGallery === selectedGallery
      ) {

        item.classList.remove(
          'variant-gallery-hidden'
        );

      } else {

        /*
         * Other Style:
         * hide it.
         */

        item.classList.add(
          'variant-gallery-hidden'
        );

      }

    });

    /*
 * If Dawn's currently active image has just
 * been hidden, activate the first matching
 * image for the newly selected Style.
 *
 * This only runs when needed, so it will NOT
 * keep jumping back to image 1 while browsing.
 */

const activeMedia =
  gallery.querySelector(
    '.product__media-item.is-active'
  );

const activeMediaIsHidden =
  !activeMedia ||
  activeMedia.classList.contains(
    'variant-gallery-hidden'
  );

if (activeMediaIsHidden) {

  const firstMatchingMedia =
    Array.from(mainItems).find(
      (item) =>
        !item.classList.contains(
          'variant-gallery-hidden'
        ) &&
        getGalleryTag(item) ===
          selectedGallery
    );

  if (firstMatchingMedia) {

    const mediaId =
      firstMatchingMedia.dataset.mediaId;

    if (
      mediaId &&
      typeof gallery.setActiveMedia ===
        'function'
    ) {

      requestAnimationFrame(() => {

        gallery.setActiveMedia(
          mediaId,
          false
        );

      });

    }

  }

}
  }


  function filterAll() {

    document
      .querySelectorAll(
        'variant-selects[data-gallery-option-position]'
      )
      .forEach((picker) => {

        filterGallery(picker);

      });

  }


  /*
   * INITIAL PAGE LOAD
   *
   * Wait one frame so Dawn can initialise
   * the product gallery first.
   */

  function initialise() {

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        filterAll();

      });

    });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialise,
      { once: true }
    );

  } else {

    initialise();

  }


  /*
   * STYLE / VARIANT CHANGE
   */

  document.addEventListener(
    'change',
    function (event) {

      const picker =
        event.target.closest(
          'variant-selects'
        );


      if (!picker) {
        return;
      }


      const sectionId =
        picker.dataset.section;


      /*
       * Give Dawn a moment to process
       * the variant and featured media first.
       */

      setTimeout(() => {

        const freshPicker =
          document.querySelector(
            `variant-selects[data-section="${sectionId}"]`
          );


        if (freshPicker) {

          filterGallery(
            freshPicker
          );

        }

      }, 120);

    }
  );


  /*
   * SHOPIFY THEME EDITOR
   */

  document.addEventListener(
    'shopify:section:load',
    initialise
  );

})();